// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3VRr5","errorLogs":"EditorFooter_errorLogs__1iwXJ"};